module.exports = __webpack_public_path__ + "static/media/30.99bffe31.svg";